import { render, staticRenderFns } from "./untung.vue?vue&type=template&id=730ec393&scoped=true&"
import script from "./untung.vue?vue&type=script&lang=js&"
export * from "./untung.vue?vue&type=script&lang=js&"
import style0 from "./untung.vue?vue&type=style&index=0&id=730ec393&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730ec393",
  null
  
)

export default component.exports